import { render, staticRenderFns } from "./Transferencia.vue?vue&type=template&id=10256df0&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/orcamento/transferencia/Transferencia.vue
// module id = 1550
// module chunks = 28